module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAAEtQTFRFAAAA//8A/7MA/7MA/70A/7gC/7gA/7YA/7kA/7cC/7gC/7cB/7cB/7cB/7cB/7cB/7cB/7cB/7gB/7cB/7cB/7YB/7cB/7cB/7cB60c+cAAAABh0Uk5TAAEKGxtwent7pKW4wMfL1Nne3vT19vj5prIYGgAAAHZJREFUGNNdj9sShDAIQ+m2Irq42tYL//+lS1t01PMUMmQgAEpATokxQMPRJpW1d3Ue5WIoDhW1d22r13xVC8wt5QHlbggCPw2GZMYv50NFvAzlk0WSRfJXmWoE5QHa2ZMt2GMn9Hp9bGVotXLkrK9HjpHRF/0Hf/UQHcA+Q4sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/com/time_orange_icon.png
// module id = ltmj
// module chunks = 24